module.exports = __webpack_public_path__ + "static/youtube-515af20389ee0282cfa40cc87a4199c0.png";